import { contractDate } from "./planningDates";

export function invoiceMonthlyTotals(invoices) {
  const groups = new Map();
  invoices.forEach(invoice => {
    const value = invoice.dateFacture || invoice.DateFacture || invoice.dateEmission || invoice.createdAt;
    const date = contractDate(value);
    if (!date) return;
    const month = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    const amount = Number(String(invoice.montantTTC ?? invoice.TotalTTC ?? 0).replace(",", "."));
    const group = groups.get(month) || {month, count: 0, cents: 0};
    group.count += 1;
    if (Number.isFinite(amount)) group.cents += Math.round(amount * 100);
    groups.set(month, group);
  });
  return [...groups.values()].sort((a, b) => b.month.localeCompare(a.month)).map(({cents, ...group}) => ({...group, amount: cents / 100}));
}
export const invoiceMonthLabel = month => new Date(Number(month.slice(0, 4)), Number(month.slice(5)) - 1, 1).toLocaleDateString("fr-FR", {month: "long", year: "numeric"});
